import React, { useState } from "react";
import { auth } from "../firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from "react-router-dom"; // Import Link
import logo from "../images/RAWWAR-02.svg";
import bgVideo from "../images/rwvideo.mp4";

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      setError("");
      console.log("email - ", email);
      if (email === "admin@dib.com") {
        navigate("/admin");
      }
      // else if (email === "pankti@dib.com" || email === "chirag@dib.com") {
      // navigate("/main");
      //}
      else {
        navigate("/dashboard");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="relative flex h-screen items-center justify-center">
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
      >
        <source src={bgVideo} type="video/mp4" />
      </video>

      <div className="absolute top-[20px] flex flex-col lg:flex-row items-center justify-center bg-[#3c603c] p-6 rounded shadow-md gap-10">
        <div className="flex-1 flex items-center justify-center">
          <img src={logo} alt="Logo" className="w-48 h-48 lg:w-80 lg:h-80" />
        </div>

        <div className="flex-1 flex items-center justify-center w-full max-w-sm">
          <form onSubmit={handleLogin} className="">
            <h2 className="text-2xl text-[#f5f7df] font-bold mb-4 text-center">
              Let The War Begin!!
            </h2>
            {error && <p className="text-red-500 mb-3">{error}</p>}
            <div className="mb-4">
              <label className="block text-[#f5f7df] mb-2">Email</label>
              <input
                type="email"
                className="w-full p-2 bg-transparent border border-[#f5f7df] rounded text-[#f5f7df] 
           focus:border-2 focus:border-[#f5f7df] focus:outline-none"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <label className="block text-[#f5f7df] mb-2">Password</label>
              <input
                type="password"
                className="w-full p-2 bg-transparent border border-[#f5f7df] rounded text-[#f5f7df] 
           focus:border-2 focus:border-[#f5f7df] focus:outline-none"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <button
              type="submit"
              className="w-full bg-[#f5f7df] text-[#3c603c] py-2 rounded border-2 border-transparent hover:bg-[#3c603c] hover:text-[#f5f7df] hover:border-[#f5f7df]"
            >
              Login
            </button>

            {/* Sign Up Link */}
            {/* <p className="text-center text-[#f5f7df] mt-4">
              Don’t have an account?{" "}
              <Link
                to="/signup"
                className="text-[#f5f7df] font-semibold underline hover:text-gray-300"
              >
                Sign up
              </Link>
            </p> */}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
